export default __webpack_public_path__ + "static/sonia-5b9efaa29c58b049c92e7fb3474836c0.jpg";